import config from '../../common/Config';

// Service functions for India Properties

// Residential Properties
export const listResidentialProperties = async () => {
    try {
        const response = await fetch(`${config.baseUrl}/api/residential-properties`);
        if (!response.ok) {
            throw new Error('Failed to fetch residential properties');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching residential properties:', error);
        throw error;
    }
};

export const deleteResidentialProperty = async (id: string) => {
    try {
        const response = await fetch(`${config.baseUrl}/api/residential-properties/${id}`, {
            method: 'DELETE',
        });
        if (!response.ok) {
            throw new Error('Failed to delete residential property');
        }
        return await response.json();
    } catch (error) {
        console.error('Error deleting residential property:', error);
        throw error;
    }
};

// Commercial Properties
export const listCommercialProperties = async () => {
    try {
        const response = await fetch(`${config.baseUrl}/api/commercial-properties`);
        if (!response.ok) {
            throw new Error('Failed to fetch commercial properties');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching commercial properties:', error);
        throw error;
    }
};

export const deleteCommercialProperty = async (id: string) => {
    try {
        const response = await fetch(`${config.baseUrl}/api/commercial-properties/${id}`, {
            method: 'DELETE',
        });
        if (!response.ok) {
            throw new Error('Failed to delete commercial property');
        }
        return await response.json();
    } catch (error) {
        console.error('Error deleting commercial property:', error);
        throw error;
    }
};

// Agricultural Properties
export const listAgriculturalProperties = async () => {
    try {
        const response = await fetch(`${config.baseUrl}/api/agricultural-lands`);
        if (!response.ok) {
            throw new Error('Failed to fetch agricultural properties');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching agricultural properties:', error);
        throw error;
    }
};

export const deleteAgriculturalProperty = async (id: string) => {
    try {
        const response = await fetch(`${config.baseUrl}/api/agricultural-lands/${id}`, {
            method: 'DELETE',
        });
        if (!response.ok) {
            throw new Error('Failed to delete agricultural property');
        }
        return await response.json();
    } catch (error) {
        console.error('Error deleting agricultural property:', error);
        throw error;
    }
};